/**
 * Thumbnail Navigation Controller
 * Makes prev/next buttons change the active thumbnail (and main image)
 * instead of just scrolling the thumbnail list
 */

function initThumbnailNavigation() {
  const thumbnailSliders = document.querySelectorAll('.thumbnail-slider');

  thumbnailSliders.forEach(slider => {
    // Skip if already initialized
    if (slider.dataset.navigationInitialized) return;
    slider.dataset.navigationInitialized = 'true';

    const prevButton = slider.querySelector('.thumbnail-navigation .slider-button--prev');
    const nextButton = slider.querySelector('.thumbnail-navigation .slider-button--next');
    const thumbnailList = slider.querySelector('.thumbnail-list');

    if (!prevButton || !nextButton || !thumbnailList) return;

    // Remove existing event listeners by cloning and replacing buttons
    const newPrevButton = prevButton.cloneNode(true);
    const newNextButton = nextButton.cloneNode(true);

    prevButton.parentNode.replaceChild(newPrevButton, prevButton);
    nextButton.parentNode.replaceChild(newNextButton, nextButton);

    function updateButtonStates() {
      // Find all thumbnail items
      const thumbnails = Array.from(thumbnailList.querySelectorAll('.thumbnail-list__item'));

      if (thumbnails.length === 0) return;

      // Find the currently active thumbnail
      let currentIndex = thumbnails.findIndex(item => {
        const button = item.querySelector('button[aria-current="true"]');
        return button !== null;
      });

      // If no active thumbnail found, assume first one
      if (currentIndex === -1) currentIndex = 0;

      // Update button disabled states
      if (currentIndex === 0) {
        newPrevButton.setAttribute('disabled', 'disabled');
      } else {
        newPrevButton.removeAttribute('disabled');
      }

      if (currentIndex === thumbnails.length - 1) {
        newNextButton.setAttribute('disabled', 'disabled');
      } else {
        newNextButton.removeAttribute('disabled');
      }
    }

    function navigateThumbnail(direction) {
      // Find all thumbnail items
      const thumbnails = Array.from(thumbnailList.querySelectorAll('.thumbnail-list__item'));

      if (thumbnails.length === 0) return;

      // Find the currently active thumbnail
      let currentIndex = thumbnails.findIndex(item => {
        const button = item.querySelector('button[aria-current="true"]');
        return button !== null;
      });

      // If no active thumbnail found, start at 0
      if (currentIndex === -1) currentIndex = 0;

      // Calculate next index - don't loop, stay at boundaries
      let nextIndex;
      if (direction === 'prev') {
        nextIndex = currentIndex - 1;
        if (nextIndex < 0) return; // Don't navigate past first
      } else {
        nextIndex = currentIndex + 1;
        if (nextIndex >= thumbnails.length) return; // Don't navigate past last
      }

      // Click the thumbnail button to activate it
      const nextThumbnail = thumbnails[nextIndex];
      const thumbnailButton = nextThumbnail.querySelector('button');

      if (thumbnailButton) {
        thumbnailButton.click();
        // Update button states after navigation
        setTimeout(updateButtonStates, 100);
      }
    }

    // Add new event listeners
    newPrevButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      navigateThumbnail('prev');
    });

    newNextButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      navigateThumbnail('next');
    });

    // Set initial button states
    updateButtonStates();
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initThumbnailNavigation);
} else {
  initThumbnailNavigation();
}

// Re-initialize on Shopify section render (for theme editor)
document.addEventListener('shopify:section:load', initThumbnailNavigation);
